module.exports = "<div class=\"wrapper wrapper-content\" id=get-started> <div class=row> <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"> <div class=ibox> <div class=ibox-content> <ng-include-start-intro-contents></ng-include-start-intro-contents> </div> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/help/introduction.html
// module id = 642
// module chunks = 86